import { render, staticRenderFns } from "./custom-img.vue?vue&type=template&id=5d35383e&scoped=true&"
import script from "./custom-img.vue?vue&type=script&lang=js&"
export * from "./custom-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35383e",
  null
  
)

export default component.exports